import { useMemo, useState, useEffect } from 'react';
import {
  CONSENT_LANGUAGES,
  IConsentConfig,
} from '@datapeace/1up-frontend-shared-api';

const ENGLISH_CODE = 'en';

export function useConsentLanguages(consentConfig?: IConsentConfig | null) {
  const languages = useMemo(() => {
    if (!consentConfig?.consent) return [];
    return Object.entries(consentConfig.consent).map(([code, text]) => ({
      code,
      label: CONSENT_LANGUAGES.find((l) => l.value === code)?.label ?? code,
      text,
    }));
  }, [consentConfig]);

  const [activeLangCode, setActiveLangCode] = useState<string>(() => {
    const hasEnglish = languages.some((l) => l.code === ENGLISH_CODE);
    return hasEnglish ? ENGLISH_CODE : languages[0]?.code ?? '';
  });

  useEffect(() => {
    if (!activeLangCode && languages.length > 0) {
      const hasEnglish = languages.some((l) => l.code === ENGLISH_CODE);
      setActiveLangCode(hasEnglish ? ENGLISH_CODE : languages[0].code);
    }
  }, [languages, activeLangCode]);

  const activeLang =
    languages.find((l) => l.code === activeLangCode) ?? languages[0];

  return { languages, activeLang, activeLangCode, setActiveLangCode };
}
